import { upsertById } from '@/processes/WsService/model/lib';
import { create } from 'zustand';

import { ICurrencyAccount } from '@/shared/lib';

export const useVabsAccountsStore = create<{
  accounts: ICurrencyAccount[];
  totalBalanceAcc: ICurrencyAccount | null;
  accountId: string;
  setAccountId: (value: string) => void;
  setAccounts: (value: ICurrencyAccount[]) => void;
  updateAccounts: (value: ICurrencyAccount) => void;
  setTotalBalanceAcc: (value: ICurrencyAccount) => void;
  resetStore: () => void;
}>((set) => ({
  accounts: [],
  accountId: '',
  totalBalanceAcc: null,
  setAccounts: (value: ICurrencyAccount[]) => {
    set({ accounts: value });
  },
  setTotalBalanceAcc: (value: ICurrencyAccount) => {
    set({ totalBalanceAcc: value });
  },
  updateAccounts: (value: ICurrencyAccount) => {
    set((state) => ({ accounts: upsertById(state.accounts, value) }));
  },
  setAccountId: (value: string) => {
    set({ accountId: value });
  },
  resetStore: () => {
    set({ accounts: [], accountId: '', totalBalanceAcc: null });
  },
}));

type TRequisites = Record<string, unknown>;

export const useRequisitesStore = create<{
  requisites: TRequisites;
  setRequisites: (value: TRequisites) => void;
  resetStore: () => void;
}>((set) => ({
  requisites: {},
  setRequisites: (value: TRequisites) => {
    set({ requisites: value });
  },
  resetStore: () => {
    set({ requisites: {} });
  },
}));

//main store
export const useAccountStore = create<{
  account: ICurrencyAccount | null; //active acc
  totalAccount: ICurrencyAccount | null; //acc in total widget
  totalBalance: number;
  setTotalBalance: (value: number) => void;
  setAccount: (value: ICurrencyAccount) => void;
  setTotalAccount: (value: ICurrencyAccount) => void;
  resetStore: () => void;
}>((set) => ({
  account: null,
  totalAccount: null,
  setAccount: (value: ICurrencyAccount) => {
    set({ account: value });
  },
  setTotalAccount: (value: ICurrencyAccount) => {
    set({ totalAccount: value });
  },
  totalBalance: 0,
  setTotalBalance: (value: number) => {
    set({ totalBalance: value });
  },
  resetStore: () => {
    set({ account: null,  totalAccount: null, totalBalance: 0});
  },
}));

//second widget
export const useWidgetAccountStore = create<{
  account: ICurrencyAccount | null;
  setAccount: (value: ICurrencyAccount) => void;
  resetStore: () => void;
}>((set) => ({
  account: null,

  setAccount: (value: ICurrencyAccount) => {
    set({ account: value });
  },
  resetStore: () => {
    set({ account: null });
  },
}));

//add money requisites modal
export const useSendAccountStore = create<{
  account: ICurrencyAccount | null;
  setAccount: (value: ICurrencyAccount) => void;
  resetStore: () => void;
}>((set) => ({
  account: null,
  setAccount: (value: ICurrencyAccount) => {
    set({ account: value });
  },
  resetStore: () => {
    set({ account: null });
  },
}));

//TODO: add other balances and merge with accounts in accounts store on update
export const useTotalBalanceStore = create<{
  totalBalance: { amount: string; symbol: string };
  setBalance: (v: { amount: string; symbol: string }) => void;
}>((set) => ({
  totalBalance: { amount: '', symbol: '' },
  setBalance: (value: { amount: string; symbol: string }) => {
    set({ totalBalance: value });
  },
  resetStore: () => {
    set({ totalBalance: { amount: '', symbol: '' } });
  },
}));
